import store from '../store/store';
import { mutatorAction } from 'satcheljs';
/**
 * Changes the runRuleNow checkbox value in the inbox rule edit store
 * @param shouldCheck value to set, sets the corresponding value in the store
 */
export default mutatorAction('setEditStateShouldRunRuleNow', function setEditStateShouldRunRuleNow(shouldCheck) {
    store.inboxRulesEditState.shouldRunRuleNow = shouldCheck;
});
//# sourceMappingURL=setEditStateShouldRunRuleNow.js.map